import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bot-page"
  }, [_c('m-head'), _c('div', {
    staticClass: "bot-main"
  }, [_c('div', {
    staticClass: "bot-head",
    style: {
      background: `url(${require(`@images/minibot/minibot-bg.jpg`)}) center/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "bot-con"
  }, [_c('div', {
    staticClass: "bot-title"
  }, [_vm._v("MINTBOT")]), _c('div', {
    staticClass: "btn-Boost",
    on: {
      "click": _vm.onBoostShow
    }
  }, [_vm._v("BOOST")])]), _c('div', {
    staticClass: "bot-store",
    style: {
      background: `url(${require(`@images/minibot/minibot-store.png`)}) center/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "bot-progress"
  }, _vm._l(10, function (_, index) {
    return _c('div', {
      key: index,
      staticClass: "bot-progress-item",
      class: {
        active: index < _vm.storeProgress
      }
    });
  }), 0), _c('img', {
    staticClass: "bot-store-anim-img",
    class: _vm.isUpgradeStore && 'isUpgradeStore',
    attrs: {
      "src": require(`@images/minibot/minibot-store.png`),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "bot-body"
  }, [_c('div', {
    staticClass: "bot-store"
  }, [_c('div', {
    staticClass: "bot-store-main"
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.storageInfo.stock.coins > 0 ? _vm.storageInfo.stock.coins : 0)) + " "), _c('span', [_vm._v("/ "), !_vm.isUpgradeStore ? [_vm._v(_vm._s(_vm.fmt_pre(_vm.storageInfo.capacity)))] : [_c('m-count-up', {
    attrs: {
      "colorVal": "#a0fe07",
      "endVal": Number(_vm.storageInfo.capacity)
    }
  })]], 2)])]), _c('div', {
    staticClass: "btn-claim",
    class: this.storageInfo?.stock?.coins <= 0 && 'disable',
    on: {
      "click": _vm.onClaim
    }
  }, [_vm.isClaimLoading ? _c('div', {
    staticClass: "circleLoading"
  }) : [_vm._v(" Claim ")]], 2), _c('div', {
    staticClass: "bot-total"
  }, [_vm._v(" Total :   "), _c('span', [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-hic.png'),
      "alt": ""
    }
  }), _vm._v("+ " + _vm._s(_vm.fmt_pre(_vm.summaryInfo.eph * _vm.poolInfo.cpb)) + "/hr ")])]), _c('div', {
    staticClass: "bot-list"
  }, _vm._l(_vm.minerList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "bot-item",
      class: (item.isLock || item.isUpgrade) && 'upgrade'
    }, [_c('transition', {
      attrs: {
        "name": "botItemToasted"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.isLock || item.isUpgrade,
        expression: "item.isLock || item.isUpgrade"
      }],
      staticClass: "bot-item-toasted"
    }, [item.isLock ? [_vm._v("Start Mining!")] : item.isUpgrade ? [_vm._v("Upgrade Successfully!")] : _vm._e()], 2)]), _c('div', {
      staticClass: "bot-item-main"
    }, [_c('div', {
      staticClass: "bot-item-pet",
      style: {
        background: `url(${require(`@images/minibot/pet-bg.jpg`)}) center/auto 100% no-repeat`
      }
    }, [_c('div', {
      staticClass: "bot-item-pet-main"
    }, [_c('img', {
      staticClass: "petAvatar",
      class: !item.active && 'activation',
      attrs: {
        "src": require(`@images/avatar/pet/${index + 1 <= 6 ? index + 1 : 6}.png`),
        "alt": ""
      }
    })])]), _c('div', {
      staticClass: "bot-item-info"
    }, [_c('div', {
      staticClass: "bot-item-info-main"
    }, [_c('div', {
      staticClass: "bot-item__tier"
    }, [_c('span', [_vm._v(" Tier " + _vm._s(item.level) + " :")]), _c('span', {
      staticClass: "value"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-hic.png'),
        "alt": ""
      }
    }), _vm._v(" +"), !item.isUpgrade ? [_vm._v(_vm._s(_vm.fmt_pre(item.current.properties.pph)))] : [_c('m-count-up', {
      attrs: {
        "colorVal": "#a0fe07",
        "endVal": Number(item.current.properties.pph)
      }
    })], _vm._v("/hr")], 2)]), _c('div', {
      staticClass: "bot-btns"
    }, [item.isPayLoading ? _c('div', {
      staticClass: "btn-upgrade"
    }, [_c('div', {
      staticClass: "circleLoading"
    })]) : !item.next ? _c('div', {
      staticClass: "btn-upgrade max"
    }, [_vm._v("Max")]) : !item.active ? _c('div', {
      staticClass: "btn-upgrade free",
      on: {
        "click": function ($event) {
          return _vm.onStartFreeShow(item, index);
        }
      }
    }, [_vm._v("Start Free")]) : _c('div', {
      staticClass: "btn-upgrade",
      on: {
        "click": function ($event) {
          return _vm.upgradeBotShow(item, index);
        }
      }
    }, [_c('svg-icon', {
      staticClass: "icon-up",
      attrs: {
        "name": "icon-up"
      }
    })], 1)])])]), _c('div', {
      staticClass: "bot-item-code"
    }, [_vm._v(_vm._s(index + 1 < 10 ? `0${index + 1}` : index + 1))])])], 1);
  }), 0)])]), _c('pop-prompt', {
    attrs: {
      "className": "pop-bot-upgrade",
      "show": _vm.popBotUpgradeShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popBotUpgradeShow = $event;
      }
    }
  }, [_vm.rowMiner ? _c('div', {
    staticClass: "popBotUpgrade"
  }, [_c('div', {
    staticClass: "popBotUpgrade-code"
  }, [_vm._v(_vm._s(_vm.rowMiner.index + 1 < 10 ? `0${_vm.rowMiner.index + 1}` : _vm.rowMiner.index + 1))]), _c('div', {
    staticClass: "popBotUpgrade-pet"
  }, [_c('img', {
    staticClass: "petAvatar",
    class: !_vm.rowMiner.active && 'activation',
    attrs: {
      "src": require(`@images/avatar/pet/${_vm.rowMiner.codeIndex}.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popBotUpgrade-info"
  }, [_c('div', {
    staticClass: "popBotUpgrade-info-item"
  }, [_c('div', {
    staticClass: "popBotUpgrade-info-item__num"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-hic.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v("+ " + _vm._s(_vm.rowMiner.hrValue) + "/hr")])]), _c('div', {
    staticClass: "popBotUpgrade-info-item__tier"
  }, [_vm._v("Tier " + _vm._s(_vm.rowMiner.level))])]), _c('div', {
    staticClass: "popBotUpgrade-info-arrow",
    domProps: {
      "innerHTML": _vm._s(_vm.svg_level_arrow)
    }
  }), _c('div', {
    staticClass: "popBotUpgrade-info-item"
  }, [_c('div', {
    staticClass: "popBotUpgrade-info-item__num"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-hic.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v("+ " + _vm._s(_vm.rowMiner.nextHrValue) + "/hr")])]), _c('div', {
    staticClass: "popBotUpgrade-info-item__tier"
  }, [_vm._v("Tier " + _vm._s(_vm.rowMiner.level + 1))])])]), _c('div', {
    staticClass: "popBotUpgrade-pay"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-main"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payType == 'Stars' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Stars');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowMiner.next.cost.stars)))])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-or"
  }, [_vm._v("OR")]), _c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payType == 'Ton' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Ton');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-ton.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowMiner.next.cost.ton)))])])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-btns"
  }, [_c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onUpgradePay
    }
  }, [!_vm.rowMiner.isPayLoading ? [_vm._v("Go")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "pop-bot-unlock-info",
      "show": _vm.popBotUnlockInfoShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popBotUnlockInfoShow = $event;
      }
    }
  }, [_vm.rowMiner ? _c('div', {
    staticClass: "popBotUnlockInfo"
  }, [_c('div', {
    staticClass: "popBotUnlockInfo-code"
  }, [_vm._v(_vm._s(_vm.rowMiner.index + 1 < 10 ? `0${_vm.rowMiner.index + 1}` : _vm.rowMiner.index + 1))]), _c('div', {
    staticClass: "popBotUnlockInfo-pet"
  }, [_c('img', {
    staticClass: "petAvatar",
    class: !_vm.rowMiner.active && 'activation',
    attrs: {
      "src": require(`@images/avatar/pet/${_vm.rowMiner.codeIndex}.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popBotUnlockInfo-tier"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon/icon-hic.png`),
      "alt": ""
    }
  }), _vm._v(" + " + _vm._s(_vm.rowMiner.hrValue) + "/hr")]), _c('div', {
    staticClass: "popBotUnlockInfo-info"
  }, [_vm.gameProgress.currentLevel < _vm.rowMiner.unlock_cost.user_level ? [_vm._v(" You can start for free after reaching LV." + _vm._s(_vm.rowMiner.unlock_cost.user_level) + " ")] : [_vm._v(" Congratulations, your level has reachedthe requirements to start for free ")]], 2), _vm.gameProgress.currentLevel < _vm.rowMiner.unlock_cost.user_level ? _c('div', {
    staticClass: "popBotUnlockInfo-level"
  }, [_c('m-level-progress', {
    ref: "mLevelProgressRef",
    attrs: {
      "width": 900,
      "progress": _vm.gameProgress.progressInfo.completion_rate * 100,
      "level": [_vm.gameProgress.currentLevel, _vm.gameProgress.nextLevel]
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "popBotUnlockInfo-btns"
  }, [_vm.gameProgress.currentLevel < _vm.rowMiner.unlock_cost.user_level ? _c('div', {
    staticClass: "btn-go",
    on: {
      "click": () => _vm.$router.push('/upgrade')
    }
  }, [_vm._v("Upgrade")]) : [_vm.isStartFreeLoading ? _c('div', {
    staticClass: "btn-go"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onStartFree
    }
  }, [_vm._v("Start Free")])]], 2)]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popMoreSpinsClass",
      "show": _vm.popStoreUpgradeShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popStoreUpgradeShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-storeUpgradePrice"
  }, [_c('div', {
    staticClass: "pop-storeUpgradePrice__title"
  }, [_vm._v("Upgraded inventory capacity")]), _c('div', {
    staticClass: "pop-storeUpgradePrice-list"
  }, [_c('transition-group', {
    staticClass: "pop-storeUpgradePrice-scroll",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.storePriceList && !_vm.storePriceListLoading ? _vm._l(_vm.storePriceList, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "pop-storeUpgradePrice-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.selectStorePrice(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "pop-storeUpgradePrice-item-main"
    }, [_c('div', {
      staticClass: "pop-storeUpgradePrice-item__num"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.count)))]), _c('div', {
      staticClass: "pop-storeUpgradePrice-item__sub"
    }, [_vm._v(_vm._s(item.off ? `${item.off}% off` : ""))]), _c('div', {
      staticClass: "pop-storeUpgradePrice-item-info"
    }, [item.isLoading ? _c('div', {
      staticClass: "loading"
    }, [_c('div', {
      staticClass: "circleLoading"
    })]) : [_c('div', {
      staticClass: "pop-storeUpgradePrice-item-info__price"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-star.png'),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(item.cost.stars)))])])]], 2)])]);
  }) : _vm._e()], 2)], 1)])]), _c('pop-prompt', {
    attrs: {
      "className": "popMoreSpinsClass",
      "show": _vm.popSelectPaymentShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popSelectPaymentShow = $event;
      }
    }
  }, [_vm.rowStorePrice ? _c('div', {
    staticClass: "pop-selectPayment"
  }, [_c('div', {
    staticClass: "pop-selectPayment__title"
  }, [_vm._v("Select payment method")]), _c('div', {
    staticClass: "popBotUpgrade-pay"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-main"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payType == 'Stars' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Stars');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowStorePrice.cost.stars)))])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-or"
  }, [_vm._v("OR")]), _c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payType == 'Ton' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Ton');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-ton.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowStorePrice.cost.ton)))])])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-btns"
  }, [_c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onPayUpgradeStore
    }
  }, [!_vm.rowStorePrice.isLoading ? [_vm._v("Payment")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])])]) : _vm._e()]), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };